import React from 'react';
import NumberFormat from 'react-number-format';

export default function PriceFormat({className, value, replaceExtension = true, tag: Tag = 'span'}) {

    return (
		<NumberFormat
			value={value}
			displayType={'text'}
			decimalSeparator={','}
			thousandSeparator={'.'}
			prefix={'€ '}
			fixedDecimalScale={true}
			decimalScale={2}
			renderText={(formatValue) => {
				return (
					<Tag className={className}>{replaceExtension ? formatValue.replace(',00', '') : formatValue}</Tag>
				);
			}}
		/>
	);
}
